import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks/redux';
import { fetchData, deleteData } from '../../actions/actions';
import { selectModelData, selectModelLoading } from '../../selectors/selectors';
import { CommentItem } from './CommentItem';
import ModalAddComment from '../addComment/modalAddComment/ModalAddComment';

interface CommentsDisplayProps {
  commentId?: number;
}

export default function CommentsDisplay({ commentId }: CommentsDisplayProps) {
  const dispatch = useAppDispatch();
  const uploadsData = useAppSelector((state) => selectModelData(state, 'gop-uploads'));
  const isLoading = useAppSelector((state) => selectModelLoading(state, 'gop-uploads'));

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editingCommentDocumentId, setEditingCommentDocumentId] = useState<string>('');
  const [editingCommentId, setEditingCommentId] = useState<number>(0);

  useEffect(() => {
    if (commentId) {
      dispatch(fetchData('gop-uploads', { CommentId: commentId }));
    }
  }, [commentId, dispatch]);

  const groupedComments = useMemo(() => {
    const currentUploads = uploadsData.filter((upload) => {
      return upload.CommentId == commentId;
    });
    if (currentUploads.length === 0) {
      return [];
    }

    const grouped = {};

    currentUploads.forEach((upload) => {
      const title = upload.Title || 'Без названия';

      if (!grouped[title]) {
        grouped[title] = {
          id: upload.id,
          documentId: upload.documentId,
          Title: title,
          CommentId: upload.CommentId,
          createdAt: upload.createdAt,
          FullName: upload.FullName,
          EmailUser: upload.EmailUser,
          Docs: [],
          uploadIds: [],
          documentIds: [],
        };
      }

      grouped[title].uploadIds.push(upload.id);
      if (upload.documentId) {
        grouped[title].documentIds.push(upload.documentId);
      } else {
        console.warn(`нет documentId!`);
      }

      if (upload.Docs) {
        if (typeof upload.Docs === 'object' && !Array.isArray(upload.Docs)) {
          grouped[title].Docs.push(upload.Docs);
        } else if (Array.isArray(upload.Docs)) {
          grouped[title].Docs.push(...upload.Docs);
        }
      }
    });

    return Object.values(grouped);
  }, [uploadsData, commentId]);

  const handleEditComment = (commentDocumentId: string) => {
    const commentToEdit = groupedComments.find((comment) => comment.documentId === commentDocumentId);

    if (commentToEdit) {
      setEditingCommentDocumentId(commentDocumentId);
      setEditingCommentId(commentToEdit.CommentId);
      setIsEditModalOpen(true);
    }
  };

  const handleDeleteComment = async (commentDocumentId: string) => {
    const commentToDelete = groupedComments.find((comment) => comment.documentId === commentDocumentId);

    if (!commentToDelete) {
      console.error('Комментарий не найден:', commentDocumentId);
      return;
    }

    try {
      if (commentToDelete.documentIds && commentToDelete.documentIds.length > 0) {
        for (const documentId of commentToDelete.documentIds) {
          dispatch(deleteData('gop-uploads', documentId));
        }
      }
    } catch (error) {
      console.error('Ошибка при удалении комментария:', error);
    }
  };

  const closeEditModal = useCallback(() => {
    setIsEditModalOpen(false);
    setEditingCommentDocumentId('');
    setEditingCommentId(0);
  }, []);

  if (groupedComments.length === 0) {
    return null;
  }

  return (
    <>
      <div className='mt-6'>
          <div className='space-y-0'>
            {groupedComments.map((comment, index) => (
              <CommentItem key={`${comment.Title}_${index}`} comment={comment} onEdit={(documentId) => handleEditComment(documentId)} onDelete={(documentId) => handleDeleteComment(documentId)} />
            ))}
          </div>
      </div>
      <ModalAddComment isOpen={isEditModalOpen} onClose={closeEditModal} mode='edit' editCommentDocumentId={editingCommentDocumentId} editCommentId={editingCommentId} />
    </>
  );
}
